module.exports = __webpack_public_path__ + "au.no1.1d5cf07e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/au.no1.jpg
// module id = NUsB
// module chunks = 0